var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import TokenType, { types } from './types';
import keywordsTree from './keywords-tree';

var isQuotes = function isQuotes(ch) {
  return ch === '"' || ch === '\'';
};
var isWhitespace = function isWhitespace(ch) {
  return ' \f\n\r\t\x0B\xA0\u2028\u2029'.indexOf(ch) !== -1;
};
var isDigit = function isDigit(ch) {
  return (/\d/.test(ch)
  );
};
var isNumber = function isNumber(ch) {
  return isDigit(ch) || ch === '.';
};
var isAlphabetic = function isAlphabetic(ch) {
  return (/[A-ZА-Я]/i.test(ch)
  );
};
var isIdentifierStart = function isIdentifierStart(ch) {
  return isAlphabetic(ch) || ch === '_' || ch === '$';
};
var isIdentifierContinue = function isIdentifierContinue(ch) {
  return isIdentifierStart(ch) || isDigit(ch) || ch === '.';
};

function skipWhitespaces(expression, index) {
  var skip = 0;

  while (isWhitespace(expression.charAt(index + skip))) {
    skip += 1;
  }

  return skip;
}

function readString(expression, index) {
  var ch = expression.charAt(index);
  var start = index + 1;
  var current = index + 1;

  while (expression.charAt(current) !== ch) {
    current += 1;
    if (current > expression.length) {
      throw new SyntaxError('Unterminated quote ' + ch);
    }
  }

  var lexeme = expression.slice(start - 1, current + 1);
  var string = expression.slice(start, current);

  return new TokenType(types.CONSTANT, lexeme, string);
}

function readNumber(expression, index) {
  var start = index;
  var current = index + 1;

  while (isNumber(expression.charAt(current))) {
    current += 1;
  }

  var lexeme = expression.slice(start, current);
  var number = Number(lexeme);

  if (isNaN(number)) {
    throw new SyntaxError('Invalid number \'' + lexeme + '\'');
  }

  return new TokenType(types.CONSTANT, lexeme, number);
}

function readIdentifier(expression, index) {
  var start = index;
  var current = index + 1;

  while (isIdentifierContinue(expression.charAt(current))) {
    current += 1;
  }

  var lexeme = expression.slice(start, current);
  return new TokenType(types.IDENTIFIER, lexeme, lexeme);
}

function readKeyword(expression, index) {
  var current = index;
  var currentNode = keywordsTree;
  var found = null;

  while (current < expression.length) {
    currentNode = currentNode.getAt(expression.charAt(current));

    if (!currentNode) {
      break;
    }

    found = currentNode.value ? currentNode : found;
    current += 1;
  }

  return found ? found.value : null;
}

var TOKENIZERS = [[isQuotes, readString], [isNumber, readNumber], [isIdentifierStart, readIdentifier]];

var Tokenizer = function () {
  function Tokenizer(input) {
    _classCallCheck(this, Tokenizer);

    this.input = input;
    this.pos = 0;
    this.skipToken();
  }

  _createClass(Tokenizer, [{
    key: 'skipToken',
    value: function skipToken() {
      if (this.pos >= this.input.length) {
        this.finishToken(new TokenType(types.EOF, '', null));
        return this;
      }

      this.pos += skipWhitespaces(this.input, this.pos);

      this.readToken();
      return this;
    }
  }, {
    key: 'readToken',
    value: function readToken() {
      var ch = this.input.charAt(this.pos);
      var keywordToken = readKeyword(this.input, this.pos);

      if (keywordToken) {
        return this.finishToken(keywordToken);
      }

      // eslint-disable-next-line no-unused-vars

      var _ref = TOKENIZERS.find(function (tokenizer) {
        return tokenizer[0](ch);
      }) || [],
          _ref2 = _slicedToArray(_ref, 2),
          match = _ref2[0],
          handler = _ref2[1];

      if (!handler) {
        throw new SyntaxError('Unknown character \'' + ch + '\'');
      }

      var token = handler(this.input, this.pos);
      return this.finishToken(token);
    }
  }, {
    key: 'finishToken',
    value: function finishToken(token) {
      this.token = token;
      this.pos += token.lexeme.length;
    }
  }]);

  return Tokenizer;
}();

export default Tokenizer;